var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("w-select", {
        attrs: {
          fancy: _vm.fancy,
          value: _vm.value,
          label: _vm.label,
          items: _vm.items,
        },
        on: {
          input: function ($event) {
            return _vm.onValue($event)
          },
        },
      })
    : _c("w-multi-select", {
        attrs: {
          "empty-text": "Geen gekozen",
          fancy: _vm.fancy,
          value: _vm.value,
          label: _vm.label,
          items: _vm.items,
        },
        on: {
          input: function ($event) {
            return _vm.onValue($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }